import { APP } from "./actions"

const initState = {
  loading: false,
  showNotification: false,
  showConfirmation: false,
  message: "",
  appId: "",
  branches: [],
}

export default (state = initState, action) => {
  const { type, payload } = action
  switch (type) {
    case APP.loading:
      state.loading = payload
      break
    case APP.notification.show:
      state.showNotification = true
      state.message = payload
      break
    case APP.notification.hide:
      //state = initState
      state.showNotification = false
      break
    case APP.confirmation.show:
      state.showConfirmation = true
      state.message = payload
      break
    case APP.confirmation.hide:
      //state = initState
      state.showConfirmation = false
      break
    case APP.appId:
      state.appId = payload
      break
    case APP.setBranches:
      state.branches = payload
      break  
    // default:
    //   state = initState
    //   break
  }
  return state
}